import React, { Component } from 'react';

import ParadigmaAsyncSeeker from '../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker';
import ParadigmaTable from "../../components/ParadigmaTable/"

import api from '../../api/';
import auth from '../../auth/';
import dateFunctions from '../functions/dateFunctions';
import DateFilter from '../../components/ParadigmaTable/DateFilter';
import Detail from './Detail.js';

import 'react-datetime/css/react-datetime.css';

class Certificacion extends Component {
    constructor() {
        super();
        this.state = {
            startDate: null,
            outerFilter: [],
            usuarioSeleccionadoId: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Fecha",
                    id: "fecha_solicitud",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha_solicitud),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa",
                    accessor: d => d.empresa,
                    show: true,
                    filterable: true,
                },
                {
                    Header: "hash_c",
                    id: "hash_c",
                    accessor: d => d.hash_c,
                    show: false,
                    private:true,
                },
                {
                    Header: "Certificación",
                    id: "certificado",
                    filterable: false,
                    className: "text-center",
                    accessor: d => (
                        d.certificacionAutorizada ? 
                            <a
                                className="ui-badge ui-badge-success"
                                target={"_blank"}
                                rel="noopener noreferrer"
                                href={api.proyectos.solicitudes.certificado + d.hash_c + "/"}
                            >
                                DESCARGAR
                            </a> : 
                            <div className="ui-badge ui-badge-danger">NO AUTORIZADA</div>),
                    show: true,
                    width: 100,
                },
                {
                    Header: "",
                    id: "certificacionAutorizada",
                    private: true,
                },
            ]
        };
    }

    onChangeUsuario(usuarioId) {
        let outerFilter = [];
        if (usuarioId){
            outerFilter.push({
                'id': 'persona_participante_id',
                'value': usuarioId
            });
        }

        this.setState({
            usuarioSeleccionadoId: usuarioId,
            outerFilter: outerFilter
        });
    }

    render() {
        const { 
            data, 
            pages, 
            loading,
            outerFilter
        } = this.state;

        return (
            <ParadigmaTable
                buttons={[
                    {
                        detail: true,
                        permission: 'solicitudes_view',
                        component: Detail,
                    },
                ]}
                outerFilter={outerFilter}
                customSearchElement={(!auth.hasPermission('administrador') ? <div></div> :
                    <div className="mimicTableHeader ui-form">
                        <section className="ui-section-block">
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <label>Usuario</label>
                                    <ParadigmaAsyncSeeker
                                        fieldName={"usuarioSeleccionadoId"}
                                        displayField={"fullname"}
                                        value={this.state.usuarioSeleccionadoId}
                                        onChange={(data) => this.onChangeUsuario(data.id)}
                                        onExternalChange={(data) => this.onChangeUsuario(data ? data.id : null)}
                                        url={api.usuarios.personal.select}
                                    />
                                </div>
                            </div>
                        </section>
                    </div>)
                }
                apiUrl={api.proyectos.cargadatos.participacion.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.cargadatos.participacion.export}
                title={"Participación por Usuario"}
            />
        );
    }
}

export default Certificacion;



// WEBPACK FOOTER //
// ./src/views/Consultas/Certificacion.js